<template>
  <div class="service-agreement">
    <p class="title">
      服务协议
    </p>

    <p class="paragraph">
      版本号：1.0
    </p>

    <p class="paragraph">
      生效日期：2024年5月6日
    </p>

    <p class="paragraph">
      一、引言
    </p>
    <p class="paragraph">
      欢迎使用上海红柚信息技术有限公司提供的SaaS版医疗器械包标签打印软件（以下简称“本服务”）。本服务协议（以下简称“本协议”）规定了您与上海红柚信息技术有限公司之间关于使用本服务的条款和条件。
    </p>

    <p class="paragraph">
      二、服务条款
    </p>
    <p class="paragraph">
      1. 服务描述：本服务允许用户通过手机APP进行医疗器械包的标签打印和管理。
    </p>
    <p class="paragraph">
      2. 服务提供：上海红柚信息技术有限公司将尽合理努力提供稳定、可靠的服务，但不对服务的连续性、无误差或无病毒等作出保证。
    </p>

    <p class="paragraph">
      三、用户注册
    </p>
    <p class="paragraph">
      1. 用户必须提供真实、准确、有效的注册信息。
    </p>
    <p class="paragraph">
      2. 用户有责任维护其账户的安全，并对账户下的所有活动负责。
    </p>

    <p class="paragraph">
      四、用户义务
    </p>
    <p class="paragraph">
      1. 用户应遵守所有适用的法律法规。
    </p>
    <p class="paragraph">
      2. 用户不得利用本服务进行非法活动或损害他人权益。
    </p>


    <p class="paragraph">
      五、服务费用
    </p>
    <p class="paragraph">
      1. 本服务可能涉及订阅费用，具体费用及支付方式将在服务开通前明确。
    </p>
    <p class="paragraph">
      2. 用户应按时支付所有费用，逾期支付可能会导致服务中断。
    </p>

    <p class="paragraph">
      六、服务变更、中断或终止
    </p>
    <p class="paragraph">
      1. 上海红柚信息技术有限公司保留随时更新或修改服务内容的权利。
    </p>
    <p class="paragraph">
      2. 在必要时，上海红柚信息技术有限公司可能中断或终止服务。
    </p>


    <p class="paragraph">
      七、知识产权
    </p>
    <p class="paragraph">
      1. 本服务的所有知识产权，包括但不限于软件、文档、图像等，均归上海红柚信息技术有限公司所有。
    </p>
    <p class="paragraph">
      2. 用户仅获得使用本服务的许可，并不拥有任何形式的所有权。
    </p>


    <p class="paragraph">
      八、免责声明
    </p>
    <p class="paragraph">
      1. 上海红柚信息技术有限公司不对因用户违反本协议而导致的任何损失承担责任。
    </p>
    <p class="paragraph">
      2. 上海红柚信息技术有限公司不对第三方通过本服务造成的损害承担责任。
    </p>

    <p class="paragraph">
      九、隐私政策
    </p>
    <p class="paragraph">
      本服务遵循上海红柚信息技术有限公司的隐私政策，该政策详细说明了我们如何收集、使用、保护和共享您的个人信息。
    </p>

    <p class="paragraph">
      十、法律适用与争议解决
    </p>
    <p class="paragraph">
      1. 本协议受中华人民共和国法律管辖。
    </p>
    <p class="paragraph">
      2. 任何因本协议引起的争议应提交至上海红柚信息技术有限公司所在地的有管辖权的法院解决。
    </p>

    <p class="paragraph">
      十一、协议的修改
    </p><p class="paragraph">
      上海红柚信息技术有限公司保留随时修改本协议的权利。任何修改将通过本服务通知用户。
    </p>

    <p class="paragraph">
      十二、联系我们
    </p>
    <p class="paragraph">
      如有任何疑问或需要帮助，请通过以下方式联系我们：
    </p>

    <p class="paragraph">
      - 电子邮件：info@honjoinfo.com
    </p>
    <p class="paragraph">
      - 地址：上海市徐汇区钦州北路1188号1幢15层1502（名义层1702室）
    </p>

    <p class="paragraph">
      十三、生效与接受
    </p>
    <p class="paragraph">
      用户通过注册或使用本服务即表示接受本协议的所有条款和条件。
    </p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
  .service-agreement {
    padding: 40px;
  }
  .title {
    text-align: center;
    font-size: 46px;
    font-weight: bold;
  }
  .paragraph {
    font-size: 42px;
    text-align: justify;
    margin: 30px 10px;
    text-indent: 84px;
  }
</style>